"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toLabel = void 0;
var capitalize_1 = require("../capitalize/capitalize");
/**
 * Transforms a key from camelCase, snake_case or dash-case
 * in to label format
 *
 * @example
 * toLabel('someLabel')
 *
 * # Result
 * 'Some Label'
 */
function toLabel(key) {
    return key
        .split(/(?=[A-Z\_\-])/)
        .map(function (word) {
        return (0, capitalize_1.capitalize)(word.replace(/\_\-/g, ''));
    })
        .join(' ');
}
exports.toLabel = toLabel;
